module.exports = __webpack_public_path__ + "static/media/icon-failed.dfd34c35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/od-icons/icon-failed.svg
// module id = 1048
// module chunks = 0